import { canceVerificationRange, cancelVerificationSelect } from "../../api";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";

const useCancelVerificationModal = ({
  handleClose,
  refetch,
  selectedItem,
  dispatch,
  updateConfig,
  approvedState,
  selectionRef,
  selectionRef2,
  // detailrefetch,
}) => {
  const initialValues = {
    status: "",
    cancelreason: "",
  };
  const validation = Yup.object({
    status: Yup.string().required("Status is required"),
    cancelreason: Yup.string().required("Enter reason for your action"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: validation,
    onSubmit: async (values) => {
      const params = approvedState?.rangefilter
        ? {
            item_details: approvedState?.certificate_number_ranges,
            stock_receipt_id: approvedState?.receipt_id,
            status: values.status,
            reason: values.cancelreason,
          }
        : {
            certificate_number: selectedItem,
            receipt_id: approvedState?.receipt_id,
            order_type: 1,
            status: values.status,
            reason: values.cancelreason,
          };

      if (approvedState?.rangefilter) {
        try {
          const response = await canceVerificationRange(params);

          if (response?.data?.status_code === 200) {
            toast.success(
              response?.data?.message ??
                "Certificate added to recheck list successfully"
            );
            selectionRef?.current?.clearValue();
            selectionRef2?.current?.clearValue();
            dispatch(
              updateConfig((state) => {
                state.certificate_number_ranges = [];
                state.rangefilter = false;
                state.selectedItem = [];
                state.clearSelection = true;
              })
            );
            const timeOut = setTimeout(() => {
              dispatch(updateConfig((state) => (state.clearSelection = false)));
              clearTimeout(timeOut);
            }, 1000);
            handleClose();
            refetch();
            // detailrefetch();
          } else {
            toast.error("Something went wrong");
            selectionRef?.current?.clearValue();
            selectionRef2?.current?.clearValue();
            dispatch(
              updateConfig((state) => {
                state.selectedItem = [];
                state.clearSelection = true;
                state.certificate_number_ranges = [];
                state.rangefilter = false;
              })
            );
            const timeOut = setTimeout(() => {
              dispatch(updateConfig((state) => (state.clearSelection = false)));
              clearTimeout(timeOut);
            }, 1000);
            handleClose();
            refetch();
            // detailrefetch();
          }
        } catch (error) {
          toast.error("API request failed");
        }
      }else if(!approvedState?.rangefilter){
        try {
          const response = await cancelVerificationSelect(params);

          if (response?.data?.status_code === 200) {
            toast.success(
              response?.data?.message ??
                "Certificate added to recheck list successfully"
            );
            selectionRef?.current?.clearValue();
            selectionRef2?.current?.clearValue();
            dispatch(
              updateConfig((state) => {
                state.certificate_number_ranges = [];
                state.rangefilter = false;
                state.selectedItem = [];
                state.clearSelection = true;
              })
            );
            const timeOut = setTimeout(() => {
              dispatch(updateConfig((state) => (state.clearSelection = false)));
              clearTimeout(timeOut);
            }, 1000);
            handleClose();
            refetch();
            // detailrefetch();
          } else {
            toast.error("Something went wrong");
            selectionRef?.current?.clearValue();
            selectionRef2?.current?.clearValue();
            dispatch(
              updateConfig((state) => {
                state.selectedItem = [];
                state.clearSelection = true;
                state.certificate_number_ranges = [];
                state.rangefilter = false;
              })
            );
            const timeOut = setTimeout(() => {
              dispatch(updateConfig((state) => (state.clearSelection = false)));
              clearTimeout(timeOut);
            }, 1000);
            handleClose();
            refetch();
            // detailrefetch();
          }
        } catch (error) {
          toast.error("API request failed");
        }

      }
    },
  });
  const statusOptions = [
  { value: 8, label: "Return" },
  { value: 7, label: "Cancel" },
];
  return { formik,statusOptions };
};
export default useCancelVerificationModal;
